import React from 'react';
const stats = [{
  icon: '📄',
  value: '+360',
  label: 'páginas'
}, {
  icon: '🏊',
  value: '150',
  label: 'sesiones'
}, {
  icon: '⚡',
  value: '80+',
  label: 'drills'
}];
const tags = ['Ambientación', 'Flotación', 'Crol y Espalda', 'Pecho y Mariposa', 'Pre-Equipo', 'Adultos y Master'];
export function SolutionSection() {
  return <section className="w-full bg-[#0A0A0F] py-14 px-4" data-id="element-198">
      <div className="max-w-3xl mx-auto text-center" data-id="element-199">
        <div className="inline-flex items-center gap-2 bg-[#FFD700] text-[#0A0A0F] font-bold text-xs px-4 py-1.5 rounded-full mb-6 tracking-wide" data-id="element-200">
          🏆 Sistema N°1 para Profesores de Natación
        </div>

        <h2 className="text-3xl sm:text-5xl font-black text-white mb-2" data-id="element-201">
          EDULABS <span className="text-[#FF6B00]" data-id="element-202">MegaPack</span>
        </h2>

        <p className="text-white text-base sm:text-lg max-w-xl mx-auto mb-6" data-id="element-203">
          <strong data-id="element-204">6 Tomos + 6 Bonos</strong> —{' '}
          <span className="text-[#FF6B00] font-bold" data-id="element-205">
            Todo resuelto, todos los niveles.
          </span>
        </p>

        {/* Stats cards */}
        <div className="grid grid-cols-3 gap-3 max-w-md mx-auto mb-8" data-id="element-206">
          {stats.map(s => <div key={s.label} className="bg-[#16161F] border border-[#FF6B0033] rounded-xl py-4 px-3" data-id="element-207">
              <span className="text-xl block mb-1" data-id="element-208">{s.icon}</span>
              <span className="text-[#FF6B00] text-2xl sm:text-3xl font-black block" data-id="element-209">
                {s.value}
              </span>
              <span className="text-[#B0B0C0] text-[10px] sm:text-xs font-semibold uppercase tracking-wider" data-id="element-210">
                {s.label}
              </span>
            </div>)}
        </div>

        {/* Tags */}
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-211">
          {tags.map(tag => <span key={tag} className="bg-[#FF6B0033] text-[#FF6B00] text-xs font-bold px-3 py-1.5 rounded-full" data-id="element-212">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}